import React, { useEffect } from 'react';
import { useBanner } from '../../context/BannerContext';
import BannerComponent from './BannerComponent';
import styles from './Banner.module.scss';
import PopUpLoginWLF from '../PopUp/PopUpLogin/PopUpLoginWLF';
import { useAuth } from '../../context/AuthContext';

const Banners: React.FC = () => {
  const { bannerMessages } = useBanner();
  const { displayLoginPopup } = useAuth();

  return (
    <div className={styles.bannersContainer}>
      {bannerMessages.map((banner, index) => (
        <BannerComponent key={index} banner={banner} />
      ))}
      <PopUpLoginWLF visible={displayLoginPopup} callback={() => {}} />
    </div>
  );
};

export default Banners;
